<template>
    <v-dialog
        v-model="dialog"
        width="800"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
        <h2 class="tw-capitalize tw-text-secondary">Advanced Search</h2>
            <v-card-text>
                <div class="tw-flex tw-flex-row tw-gap-4 tw-pt-2">
                    <v-select
                        label="Search Select"
                        v-model="searchSelectionValue"
                        :items="searchSelectionList"
                        class="tw-pr-2 tw-mr-2"
                        outlined
                        dense
                        clearable
                    ></v-select>

                    <date-picker
                        v-show="searchSelectionValue == 'Birthdate'"
                        v-model="filters.dob"
                        :isRange="true"
                        dense
                        color="primary"
                        label="Birthdate"
                        display-label="Birthdate"
                        class="tw-w-2/3"
                        ref="birthdayDatePicker"
                        hide-details
                        clearable
                    />
                    <v-text-field
                        v-show="searchSelectionValue == 'Address'"
                        v-model="filters.address"
                        label="Address"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-text-field>
                    <v-autocomplete
                        v-show="searchSelectionValue == 'Gender'"
                        v-model="filters.gender"
                        :items="valuelists.GENDERS"
                        label="Gender"
                        hide-details="auto"
                        :menu-props="{top: true}"
                        multiple
                        dense
                        reactive
                        outlined
                        clearable
                    ></v-autocomplete>
                    <v-select
                        v-show="searchSelectionValue == 'CASL'"
                        v-model="filters.casl"
                        :items="yesNoList"
                        label="CASL"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == 'Web Access'"
                        v-model="filters.web_access"
                        :items="yesNoList"
                        label="Web Access"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == 'Producer Access'"
                        v-model="filters.producer_access"
                        :items="yesNoList"
                        label="Producer Access"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == '25/65'"
                        v-model="filters.age_25_and_65"
                        :items="yesNoList"
                        label="25/65"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == 'IA Retiree'"
                        v-model="filters.ia_retiree"
                        :items="yesNoList"
                        label="IA Retiree"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == 'Region'"
                        v-model="filters.region"
                        :items="getRegions"
                        label="Region"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-select
                        v-show="searchSelectionValue == 'Role'"
                        v-model="filters.role"
                        :items="Object.values(constants.USER_ROLES)"
                        label="User Access"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-select>
                    <v-text-field
                        v-show="searchSelectionValue == 'Phone Number'"
                        v-model="filters['telephones.telephone_fax']"
                        label="Phone Number"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-text-field>
                    <v-text-field
                        v-show="searchSelectionValue == 'SIN'"
                        v-model="filters.nas"
                        label="SIN"
                        outlined
                        dense
                        class="tw-w-2/3"
                        clearable
                    ></v-text-field>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    text
                    @click="closeModal"
                    class="main-btn"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";

export default {
    name: "MembersAdvancedSearchModal",
    components: {
        DatePicker,
    },
    props: {
        'value': {
            type: Boolean,
            required: true,
        },
        'filtersProp': {
            type: Object,
            required: true,
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'valuelists': {
            type: Object,
            required: true,                     // we require VL_CLASSIFICATIONS
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            dialog: this.value || false,
            filters: this.filtersProp || {},
            searchSelectionValue: null,
            searchSelectionList: [
                {text: '25/65', value: '25/65'},
                {text: 'Address', value: 'Address'},
                {text: 'Birthdate', value: 'Birthdate'},
                {text: 'CASL', value: 'CASL'},
                {text: 'Gender', value: 'Gender'},
                {text: 'IA Retiree', value: 'IA Retiree'},
                {text: 'Phone Number', value: 'Phone Number'},
                {text: 'Producer Access', value: 'Producer Access'},
                {text: 'Region', value: 'Region'},
                {text: 'User Access', value: 'Role'},
                {text: 'SIN', value: 'SIN'},
                {text: 'Web Access', value: 'Web Access'},
            ],
            yesNoList: [
                {text: 'Yes', value: '1'},
                {text: 'No', value: '0'},
            ]
        }
    },
    methods: {
        closeModal() {
            this.dialog = false
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            if (newDialog === false) {
                this.$emit('advanced_search_closed', newDialog)
            }
        },
    },
    computed: {
        getRegions() {
            return Object.values(this.constants.MEMBER_REGIONS)
        },
    }
}
</script>

<style scoped>

</style>
